/* global $, bootstrap */
import '../scss/styles.scss'
import 'bootstrap-select/js/bootstrap-select'
import 'bootstrap-select/js/i18n/defaults-ru_RU'
import {createApiReference} from '@scalar/api-reference'

export function PoolList() {
    initTooltip()

    const options = {
        afterClose() {
            reload()
        },
        beforeShow(modalObject, modalForm) {
            selectpicker(modalForm)
        }
    }

    bindShowModal($('.js-show-modal'), options)

    $('.js-filter-toggle').on("click", function () {
        $('.js-filter').toggle()
    })
}

export function SessionList() {
    initTooltip()

    $('.js-filter-toggle').on("click", function () {
        $('.js-filter').toggle()
    })
}


export function TenantList() {
    initTooltip()

    const options = {
        afterClose() {
            reload()
        },
        beforeShow(modalObject, modalForm) {
            selectpicker(modalForm)
        }
    }

    bindShowModal($('.js-show-modal'), options)

    $('.js-filter-toggle').on("click", function () {
        $('.js-filter').toggle()
    })
}

export function UserList() {
    initTooltip()

    const options = {
        afterClose() {
            reload()
        },
        beforeShow(modalObject, modalForm) {
            selectpicker(modalForm)
        }
    }

    bindShowModal($('.js-show-modal'), options)

    $('.js-filter-toggle').on("click", function () {
        $('.js-filter').toggle()
    })
}


function reload() {
    window.location.reload()
}

function bindShowModal(selector, options) {
    selector.on('click', e => {
        e.preventDefault()
        const url = e.currentTarget.href
        fetchModalForm(url, options)
    })
}

export function processResponse(response, options) {
    if (response.form) {
        showModal($(response.form), options, response)
    } else if (response.model) {
        if (options.afterClose) {
            options.afterClose(response, options)
        }
        return true
    } else if (response.location) {
        window.location = response.location
        return true
    } else {
        showError(Error('Invalid response'))
    }

    return false
}

function fetchModalForm(url, options) {
    fetch(url, options)
        .then(parseJsonResponse)
        .then(json => processResponse(json, options))
        .catch(e => showError(e))
}

function parseJsonResponse(response) {
    if (!response.ok) {
        const error = Object.assign(Error(response.statusText), {
            status: response.status
        })
        throw error
    }

    return response.json()
}

function showError(e) {
    if (e.status === 403) {
        alert('Операция запрещена')
    } else {
        alert(e.toString())
    }
}


export function showModal(modalForm, options, result) {
    const modalObject = new bootstrap.Modal(modalForm[0])

    modalForm.on('show.bs.modal', () => {
        if (options.beforeShow) {
            options.beforeShow(modalObject, modalForm, options, result)
        }
    })
    modalForm.on('shown.bs.modal', () => {
        if (options.afterShow) {
            options.afterShow(modalObject, modalForm, options, result)
        }
    })
    modalForm.on('hide.bs.modal', () => {
        if (options.beforeHide) {
            options.beforeHide(modalObject, modalForm, options, result)
        }
    })
    modalForm.on('hidden.bs.modal', () => {
        modalForm.remove()
        if (options.afterHide) {
            options.afterHide(modalObject, modalForm, options, result)
        }
    })
    modalForm.on('click', '.js-submit', e => {
        e.preventDefault()
        return submitForm(modalObject, options, modalForm)
    })
    modalObject.show()
}

export function submitForm(modalObject, options, modalForm) {
    const el = modalForm.find('form')[0]
    const body = new URLSearchParams(new FormData(el))

    return fetch(el.action, {method: el.method, body: body})
        .then(parseJsonResponse)
        .then(response => {
            if (response.form) {
                const updatedModal = $(response.form)
                modalForm.find('.modal-content').replaceWith(
                    updatedModal.find('.modal-content')
                )
                if (options.beforeShow) {
                    options.beforeShow(modalObject, modalForm, options, response)
                }
                return false
            }

            if (processResponse(response, options)) {
                modalObject.hide()
            }
        })
        .catch(e => showError(e))
}

function selectpicker(root) {
    $('.selectpicker', root).selectpicker()
}

function initTooltip() {
    $('[data-bs-toggle="tooltip"]').each((i, e) => new bootstrap.Tooltip(e))
}


export function ApiDoc(url: string, token: string) {
    const darkMode = false
    const hideDarkModeToggle = true
    const hideClientButton = true

    let authentication = {}
    if (token) {
        authentication = {
            securitySchemes: {
                bearerAuth: {
                    token: token
                }
            }
        }
    }

    createApiReference('#app', {
        url,
        darkMode,
        hideDarkModeToggle,
        hideClientButton,
        authentication,
        localization: {locale: 'ru'}
    })
}
